import { useTheme } from "@emotion/react";
import useStyles from "./styles";

import { Chip, Grid, Paper, Tooltip, Typography } from "@mui/material";
import {
  ArticleOutlined,
  CheckCircleOutlineOutlined,
  DriveFileRenameOutlineOutlined,
} from "@mui/icons-material";
import { maskCnpj, maskPhone } from "../../../utils/masks";
import dayjs from "dayjs";
import { formatDescricao } from "../../../utils/formatTicket";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";

export default function DescricaoTicketComponentVero(params) {
  const { ticketDetails, erp = "", isOsIxc = false } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Box sx={styles.containerBodyModal}>
      <>
        <Box sx={styles.boxEdit}>
          <Typography sx={styles.titleDescription}>
            <ArticleOutlined sx={{ fontSize: "18px" }} />
            Informações de cadastro
          </Typography>
        </Box>
        <Box sx={styles.boxBodyModal}>
          <Paper
            variant="outlined"
            elevation={0}
            sx={styles.containerPaperModal}
          >
            <Grid
              container
              spacing={1}
              columns={{ xs: 1, sm: 2, md: 6, lg: 8, xl: 8, xxl: 8 }}
            >
              <Grid item xs={1} sm={2} md={3} lg={4}>
                <Box sx={styles.containerDataDescription}>
                  <Tooltip title={ticketDetails?.cliente?.nome || ""}>
                    <Box sx={styles.boxDescription}>
                      <Typography sx={styles.nameDescription}>Nome:</Typography>
                      <Typography sx={styles.valueDescription}>
                        {ticketDetails?.cliente?.nome || ""}
                      </Typography>
                    </Box>
                  </Tooltip>
                  <Tooltip title={maskCnpj(ticketDetails?.cliente?.cnpj || "")}>
                    <Box sx={styles.boxDescription}>
                      <Typography sx={styles.nameDescription}>CNPJ:</Typography>
                      <Typography sx={styles.valueDescription}>
                        {maskCnpj(ticketDetails?.cliente?.cpf_cnpj || "")}
                      </Typography>
                    </Box>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={1} sm={2} md={3} lg={4}>
                <Box sx={styles.containerDataDescription}>
                  <Tooltip
                    title={dayjs(ticketDetails?.data_cadastro_timestamp).format(
                      "DD/MM/YY HH:mm",
                    )}
                  >
                    <Box sx={styles.boxDescription}>
                      <Typography sx={styles.nameDescription}>
                        Data de Cadastro:
                      </Typography>
                      <Typography sx={styles.valueDescription}>
                        {dayjs(ticketDetails?.data_cadastro_timestamp).format(
                          "DD/MM/YY HH:mm",
                        )}
                      </Typography>
                    </Box>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={1} sm={2} md={3} lg={4}>
                <Box sx={{ width: "100%" }}></Box>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </>
    </Box>
  );
}
